import { useMutation } from "react-query";
import { CasPurposesApi } from "@jti/rest-api";
import { buildContestPayload, extractConsents } from "../utils";
import { useSubmitContest } from "./useSubmitContest";
export const useLoyaltyContestSubmit = () => {
    const handleStartContest = useSubmitContest();
    return useMutation({
        mutationFn: async ({ formValues, user, consentFields }) => {
            if (!user?.uuid || !user?.ciam_token) {
                throw new Error("Missing user credentials");
            }
            const casPurposesApi = CasPurposesApi.init();
            if (consentFields.length > 0) {
                const consentValues = extractConsents(formValues, consentFields);
                await casPurposesApi.updateUserConsentsEvo(consentValues);
            }
            const contestPayload = buildContestPayload(formValues);
            await handleStartContest.mutateAsync({
                uuid: user.uuid,
                ciam_token: user.ciam_token,
                formData: contestPayload,
            });
        },
        retry: false,
    });
};
//# sourceMappingURL=useLoyaltyContestSubmit.js.map